// extracted by mini-css-extract-plugin
export default {"verticalSection":"VerticalSection_verticalSection__b6yKp","body":"VerticalSection_body__G07w3","errorBox":"VerticalSection_errorBox__OZKso"};